import { render, staticRenderFns } from "./ProductsAndOffersContainer.vue?vue&type=template&id=a22265d8&scoped=true"
import script from "./ProductsAndOffersContainer.vue?vue&type=script&lang=js"
export * from "./ProductsAndOffersContainer.vue?vue&type=script&lang=js"
import style0 from "./ProductsAndOffersContainer.vue?vue&type=style&index=0&id=a22265d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22265d8",
  null
  
)

export default component.exports